export default "__VITE_ASSET__1d74b038__"